<div class="assignee-select" [class.border-focused]="focusAssigneeInput">

  <nb-form-field>
    <nb-user color="rgba(9, 30, 66, 0.04)" size="small"
             onlyPicture nbPrefix
             [showInitials] = "selectedAssignee.picture === null"
             [name]="selectedAssignee.header"
             [picture]="getImageSrc(selectedAssignee.picture)">
    </nb-user>
    <input [formControl]="inputAssigneeControl"
           (click)="showSearchAssignee()"
           (focus)="inputAssigneeElement.select()"
           (blur)="blurAssignee($event)"
           [nbAutocomplete]="auto"
           #inputAssigneeElement
           nbInput type="text"/>
    <button nbSuffix nbButton ghost *ngIf="focusAssigneeButton && !isEmptyAssignee" class="dont-reset" nbTooltip="Очистить" (click)="clearAssignee()">
      <nb-icon [icon]="'close-outline'"></nb-icon>
    </button>

    <nb-autocomplete #auto (selectedChange)="onChangeAssignee($event)">
      <nb-option *ngFor="let executor of store.items$ | async" [value]="executor" class="nb-option dont-reset">
        <nb-user color="rgba(9, 30, 66, 0.04)" size="small"
                 [showInitials] = "executor.picture === null"
                 [name]="executor.header"
                 [picture]="getImageSrc(executor.picture)">
        </nb-user>
      </nb-option>
    </nb-autocomplete>

  </nb-form-field>
</div>
